import React, { useRef } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { motion, useElementScroll, useTransform } from 'framer-motion';
import { useEase } from './motion';
import { FooterBrand, FooterLinks, FooterSocial } from './footer';
import { TransitionCover } from '../components/transition'

export const ChapterMenu = (props) => {

	const scrollRef = useRef()
	const { scrollYProgress } = useElementScroll(scrollRef)

	const containerAnime = {
		closed: {
			x: '-100%',
			transition: {
				ease: useEase('easeOutExpo'),
				duration: 0.5,
				delay: 0.4,
			},
		},
		open: {
			x: 0,
			transition: {
				ease: useEase('easeInExpo'),
				duration: .6,
				staggerChildren: 0.05,
				delayChildren: 0.4,
			}
		}
	}

	const itemAnime = {
		closed: {
			x: '-100%',
			opacity: 0,
			transition: {
				duration: 0.75,
			},
		},
		open: {
			x: 0,
			opacity: 1,
			transition: {
				type: 'spring',
				duration: 1,
			},
		}
	}

	return (
		<StaticQuery
			query={graphql`
				query {
					allStrapiChapter(
						sort: { order: ASC, fields: chapter_number }
					) {
						edges {
							node {
								UID
								chapter_title
								chapter_number
							}
						}
					}
				}
			`}
			render={data => (
				<motion.nav
					className="primary-nav"
					variants={containerAnime}
					initial="closed"
					animate={props.menuOpen ? "open" : "closed"}
					exit="closed"
				>
					<div className="primary-nav-content">
						<div className="nav-header">Explore the Moments</div>
						<NavScrollArrows yValue={scrollYProgress} />
						<div className="nav-container">
							<div className="nav-grid" ref={scrollRef}>
								{data.allStrapiChapter.edges.map(
									({ node }, index) => (
										<motion.div
											key={index}
											className="nav-grid-item"
											variants={itemAnime}
										>
											<TransitionCover
												cover
												to={`/${node.UID}`}
												activeClassName="current-page"
												direction="up"
												duration={1.8}
												bg="#ff0000"
											>
												<div className="nav-chapter-number">
													{(
														"0" +
														node.chapter_number
													).slice(-2)}
												</div>
												<div className="nav-chapter-nav-name">
													{node.chapter_title}
												</div>
											</TransitionCover>
										</motion.div>
									)
								)}
								{props.menuBreakpoint === "mobile" && (
									<div className="nav-mobileFooter">
										<FooterSocial />
										<FooterLinks />
										<FooterBrand />
									</div>
								)}
							</div>
						</div>
					</div>
				</motion.nav>
			)}
		/>
	)
}


export const NavScrollArrows = (props) => {

	return (
		<div className="nav-arrows">
			<motion.svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 6.01 77.2"
				height="77.2"
				width="6.01"
				className="navDownUp"
				style={{
					opacity: props.yValue,
				}}
			>
				<g id="thinArrowUp">
					<path d="M3,0,6,5.47H0Z" fill="currentColor" />
					<path d="M3.16,4V77.2" fill="none" stroke="currentColor" />
				</g>
			</motion.svg>
			<motion.svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 6.01 77.2"
				height="77.2"
				width="6.01"
				className="navDownArrow"
				style={{
					opacity: useTransform(props.yValue, [0, 1], [1, 0]),
				}}
			>
				<g id="thinArrowDown">
					<path d="M3,77.2,0,71.73H6Z" fill="currentColor" />
					<path d="M2.85,73.25V0" fill="none" stroke="currentColor" />
				</g>
			</motion.svg>
		</div>
	)
}